<!--<div class="text-3xl">Recommended Spaces</div>-->

<app-carousel2>
  <ng-container *ngFor="let location of list">
    <ng-container *carouselItem>
      <app-location-card [location]="location"></app-location-card>
    </ng-container>
  </ng-container>
</app-carousel2>